<template>
  <div class="main-page wap">
    <Header></Header>
    <Banner></Banner>
    <Carousel :isSelf="true"></Carousel>
    <div class="m-wap-page page-bottom">
      <List></List>
    </div>
    <div
      v-if="extraItem.extras('copyright.display')"
      class="m-copyright"
      :style="{
        textAlign: extraItem.extras('copyright.position'),
        color: extraItem.extras('copyright.color'),
        fontSize:
          extraItem.extras('copyright.fontSize') === 'big'
            ? pxOrVw(28)
            : extraItem.extras('copyright.fontSize') === 'small'
            ? pxOrVw(20)
            : pxOrVw(24),
        fontWeight:
          extraItem.extras('copyright.bold') === 'bold' ? 'bold' : 'normal',
        fontStyle:
          extraItem.extras('copyright.italic') === 'italic'
            ? 'italic'
            : 'normal',
        whiteSpace: 'pre-line',
        paddingBottom: pxOrVw(30)
      }"
    >
      {{ extraItem.extras("copyright.model") }}
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../../components/Header";
// import Column from "../../components/Column.vue";
import Banner from "../../components/Banner.vue";
import List from "../../components/Wap/List.vue";
import Carousel from "../../components/Wap/Carousel.vue";
import { $subscriber } from "fire-wind-water";
// import $ from "jquery";

export default {
  name: "Article",
  data() {
    return {
      extras: {}
    };
  },
  components: {
    Header,
    // Column,
    Banner,
    List,
    Carousel
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.extras = res;
    });
  }
};
</script>
